import { v4 } from 'uuid'

import { PUBLIC_APP } from 'common/metadata-constants'
import window from 'common/window'

const KEY = 'sessionId'

const get = () => {
  return window.localStorage.getItem(KEY)
}

const set = () => {
  const sessionId = v4()
  window.localStorage.setItem(KEY, sessionId)
  return sessionId
}

export const clear = () => {
  window.localStorage.removeItem(KEY)
}

const getSessionId = (app: string) => {
  if (app !== PUBLIC_APP) return
  const sessionId = get()
  return sessionId || set()
}

export default getSessionId
